import React from "react";

const Header = () => {
  // To delete the hosted File https://postimg.cc/zVJgRw3p/9298368a
  return <img src="https://i.postimg.cc/bNnHW3PX/header.png" alt="Header" />;
};

export default Header;
